import React, { useEffect, useState } from "react";
import { useDispatch , useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Navdata = ({ User_Role }) => {
  const history = useNavigate();
  const dispatch = useDispatch();

  const [isBotSetting, setIsBotSetting] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("BotSetting");
      const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
  

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "BotSetting") {
      setIsBotSetting(false);
    }
  }, [history, isBotSetting]);

  // Dynamically filter menu items based on User_Role
  const menuItems = [
    {
      id: "BotThreads",
      label: "Bot threads",
      link: "#",
      icon: "ri-window-2-line",
    },
    {
      id: "FavePrompt",
      label: "Favourite Prompt",
      link: "#",
      icon: "bx bxs-heart-circle",
    },
    {
      id: "BotUser",
      label: "Bot User",
      link: "#",
      icon: "ri-account-circle-line",
    },
    {
      id: "BotSetting",
      label: "Bot setting",
      icon: "ri-settings-2-line",
      link: "#",
      click: function (e) {
        e.preventDefault();
        setIsBotSetting(!isBotSetting);
        setIscurrentState("BotSetting");
        updateIconSidebar(e);
      },
      stateVariables: isBotSetting,
      subItems: User_Role === "BotUser"
        ? [
            {
              id: "Configuration",
              label: "Configuration",
              link: "#",
              parentId: "BotSetting",
            },
          ]
        : [
            {
              id: "Configuration",
              label: "Configuration",
              link: "#",
              parentId: "BotSetting",
            },
            {
              id: "bot_description",
              label: "Bot description",
              link: "#",
              parentId: "BotSetting",
            },
            {
              id: "bot_instruction",
              label: "Bot instruction",
              link: "#",
              parentId: "BotSetting",
            }, 
            {
              id: "sample_question",
              label: "Sample question",
              link: "#",
              parentId: "BotSetting",
            },
                       
            {
              id: "Knowledge",
              label: "Knowledge",
              link: "#",
              parentId: "BotSetting",
            },
            {
              id: "SQL_Instruction",
              label: BotDetails.Type=='DBLink'?"SQL Instruction":" ",
              link: "#",
              parentId: "BotSetting",
            },
            // {
            //   id: "Tool",
            //   label: "Tools",
            //   link: "#",
            //   parentId: "BotSetting",
            // },
          ],
    },
  ];

  const filteredMenuItems =
    User_Role === "Viewer"
      ? menuItems.filter(
          (item) =>
            item.id === "FavePrompt" ||
            item.id === "BotUser" 
            
        )
      : menuItems;

  return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};

export default Navdata;
